module.exports = __webpack_public_path__ + "img/email.6c1b8573.png";